<template>
  <Modal 
    v-model="show" 
    :title="$t('bao-jing-dan-chuang')" 
    :width="80" 
    footer-hide 
    @on-cancel="cancel" 
    class-name="vertical-center-modal alarm-modal-management"
  >
    <audio ref="alarmAudio" loop autoplay></audio>
    
    <div class="management-container">
      <!-- 背景：沉浸式地图 -->
      <div class="map-background">
        <div id="alarmMapId" class="map-canvas"></div>
        <!-- HUD 地址显示 -->
        <div class="hud-address-clean" v-if="alarmData && alarmData.addr">
          <div class="hud-icon-box">
            <Icon type="md-pin" />
          </div>
          <span class="hud-text">{{ alarmData.addr }}</span>
        </div>
        <!-- 无定位信息提示 -->
        <div class="no-location-tip" v-if="alarmData && (!alarmData.lng || !alarmData.lat)">
          <span>{{ $t('wu-ding-wei-xin-xi') }}</span>
        </div>
      </div>

      <!-- 左侧：悬浮报警卡片列表 -->
      <div class="white-panel panel-left">
        <div class="panel-header">
          <div class="header-title">
            <div class="status-indicator"></div>
            <span>{{ $t('bao-jing-lie-biao') }}</span>
          </div>
          <div class="panel-badge">{{ (alarmList || []).length }}</div>
        </div>
        
        <div class="list-scroll">
          <div v-if="!alarmList || alarmList.length === 0" class="empty-state">
            <Icon type="md-notifications-off" size="40" color="#f0f0f0" />
            <p>{{ $t('wu-bao-jing-xin-xi') }}</p>
          </div>
          <div 
            v-else
            v-for="(item, index) in alarmList" 
            :key="index" 
            class="management-card" 
            :class="{'is-active': index === currentIndex}" 
            @click="selAlarm(item, index)"
          >
            <div class="card-body">
              <div class="card-icon-box">
                <img :src="$fullImage('/image/screen/alarm-'+item.alarm_type_id+'.png')" class="type-icon" />
              </div>
              <div class="card-info">
                <div class="info-type">{{ item.alarm_type }}</div>
                <div class="info-time">{{ item.create_time ? item.create_time.split(' ')[1] : '' }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧：详情面板 -->
      <div class="white-panel panel-right">
        <div class="panel-section">
          <div class="section-title">
            <Icon type="md-contact" size="16" />
            <span>{{ $t('dang-an-xian-xi') }}</span>
          </div>
          <div class="section-content">
            <template v-if="alarmData && alarmData.files">
              <div class="profile-hero">
                <Avatar :src="alarmData.files.head_img" size="60" class="clean-avatar" />
                <div class="hero-text">
                  <div class="h-name">{{ alarmData.files.name }}</div>
                  <div class="h-code">{{ alarmData.files.code }}</div>
                </div>
              </div>
              <div class="data-item" v-if="alarmData.files.belong_name">
                <span class="label">{{ $t('shuo-shu-qi-ye') }}：</span>
                <span class="value">{{ alarmData.files.belong_name }}</span>
              </div>
              <div class="data-item">
                <span class="label">{{ $t('shou-ji-hao') }}：</span>
                <span class="value">{{ alarmData.files.phone || '—' }}</span>
              </div>
              <div class="data-item" v-if="alarmData.files.sex !== undefined && alarmData.files.sex !== null">
                <span class="label">{{ $t('xing-bie') }}：</span>
                <span class="value">{{ alarmData.files.sex == 1 ? $t('nan') : alarmData.files.sex == 2 ? $t('nv') : '—' }}</span>
              </div>
              <div class="data-item" v-if="alarmData.files.age !== undefined && alarmData.files.age !== null">
                <span class="label">{{ $t('nian-ling') }}：</span>
                <span class="value">{{ alarmData.files.age }}</span>
              </div>
            </template>
            <div v-else class="no-data">{{ $t('wei-bang-ding') }}</div>
          </div>
        </div>

        <div class="divider"></div>

        <div class="panel-section">
          <div class="section-title">
            <Icon type="md-cube" size="16" />
            <span>{{ $t('she-bei-xin-xi') }}</span>
          </div>
          <div class="section-content">
            <div class="profile-hero" v-if="alarmData && alarmData.model">
              <Avatar :src="alarmData.model.logo" size="60" class="clean-avatar" />
              <div class="hero-text">
                <div class="h-name">{{ alarmData.nickName || $t('wu') }}</div>
                <div class="h-code">{{ alarmData.device_id }}</div>
              </div>
            </div>
            <div class="data-item">
              <span class="label">{{ $t('she-bei-shou-ji-hao') }}</span>
              <span class="value">{{ (alarmData && alarmData.devicePhone) || '—' }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader'
import md5 from 'js-md5'

export default {
  name: 'DevAlarmPop',
  props: {
    mqttClient: { required: true }
  },
  data () {
    return {
      show: false,
      alarmList: [],
      alarmData: { files: {}, model: {}, institution: {} },
      audioElement: null,
      mapInfo: { AMap: null, Map: null, marker: null, circular: null },
      currentIndex: 0,
      subscribed: false,
      currentTopic: null,
      messageHandler: null
    }
  },
  mounted () {
    this.audioElement = this.$refs.alarmAudio
    this.initMap()
  },
  methods: {
    subscribe () {
      if (!this.mqttClient || !this.mqttClient.connected) return
      if (this.subscribed && this.currentTopic) this.unsubscribe()
      const domain = this.CurrentDomain || window.location.hostname
      let topic = md5(domain) + `/Device/Alarm`
      if (this.$store.state.applyInfo && this.$store.state.applyInfo.apply_id) {
        topic += `/apply_${this.$store.state.applyInfo.apply_id}`
      } else if (this.$store.state.userInfo) {
        topic += `/apply_${this.$store.state.userInfo.applyId}`
      }
      if (this.$store.state.labelType == 0) {
        topic += `/institution_0`
      } else if (this.$store.state.insInfo) {
        topic += `/institution_${this.$store.state.insInfo.id}`
      }
      if (this.subscribed && this.currentTopic === topic) return
      if (this.messageHandler) this.mqttClient.removeListener('message', this.messageHandler)
      this.messageHandler = (tpc, message) => {
        if (tpc !== topic) return
        try {
          const { alarmData, alarmAudio } = JSON.parse(message.toString())
          const language = localStorage.getItem('language')
          if (language && language !== 'zh-cn' && alarmData.languageAlarmType) {
            alarmData.alarm_type = alarmData.languageAlarmType[language]
          }
          this.alarmList.unshift(alarmData)
          this.alarmData = alarmData
          this.currentIndex = 0
          this.updateMap()
          if (alarmAudio && this.audioElement) {
            this.audioElement.src = alarmAudio
            this.audioElement.play().catch(e => console.error('播放失败:', e))
          }
          this.show = true
        } catch (e) {
          console.error('消息处理失败:', e)
        }
      }
      this.mqttClient.on('message', this.messageHandler)
      this.mqttClient.subscribe(topic, { qos: 1 }, (err) => {
        if (!err) { this.subscribed = true; this.currentTopic = topic; }
      })
    },
    unsubscribe () {
      if (!this.mqttClient) return
      if (this.messageHandler) { this.mqttClient.removeListener('message', this.messageHandler); this.messageHandler = null; }
      if (this.currentTopic) { this.mqttClient.unsubscribe(this.currentTopic); this.currentTopic = null; }
      this.subscribed = false
    },
    cancel () {
      this.alarmList = []
      if (this.audioElement) { this.audioElement.pause(); this.audioElement.src = ''; }
    },
    initMap () {
      const key = this.AutonaviMapKey || ''
      AMapLoader.load({
        key: key,
        version: '2.0',
        plugins: ['AMap.CircleEditor']
      }).then((AMap) => {
        this.mapInfo.AMap = AMap
        this.mapInfo.Map = new AMap.Map('alarmMapId', {
          viewMode: '2D',
          zoom: 17,
          mapStyle: 'amap://styles/grey',
          center: [116.397428, 39.90923]
        })
      })
    },
    updateMap () {
      if (!this.mapInfo.Map) return
      // 清除之前的标记
      if (this.mapInfo.marker) {
        this.mapInfo.Map.remove(this.mapInfo.marker)
        this.mapInfo.marker = null
      }
      if (this.mapInfo.circular) {
        this.mapInfo.Map.remove(this.mapInfo.circular)
        this.mapInfo.circular = null
      }
      
      // 判断是否有定位信息
      if (this.alarmData && this.alarmData.lng && this.alarmData.lat) {
        // 有定位信息，显示标记
        let markerArray = []
        markerArray.push(this.createMarker(this.alarmData.lng, this.alarmData.lat))
        if (this.alarmData.fence) {
          markerArray.push(this.createCircular(this.alarmData.fence.longitude, this.alarmData.fence.latitude, this.alarmData.fence.radius))
        }
        this.mapInfo.Map.setFitView(markerArray)
      }
    },
    createMarker (lng, lat) {
      // 融合后的未来感标记
      const content = `
        <div class="futuristic-marker">
          <div class="marker-core"></div>
          <div class="marker-ring marker-ring-1"></div>
          <div class="marker-ring marker-ring-2"></div>
          <div class="marker-ring marker-ring-3"></div>
        </div>
      `
      const marker = new this.mapInfo.AMap.Marker({
        position: new this.mapInfo.AMap.LngLat(lng, lat),
        content: content,
        offset: new this.mapInfo.AMap.Pixel(-15, -15)
      })
      this.mapInfo.marker = marker
      this.mapInfo.Map.add(marker)
      return marker
    },
    createCircular (lng, lat, radius) {
      const circular = new this.mapInfo.AMap.Circle({
        center: new this.mapInfo.AMap.LngLat(lng, lat),
        radius: radius,
        strokeColor: '#FF4D4F',
        strokeOpacity: 0.5,
        strokeWeight: 2,
        fillColor: '#FF4D4F',
        fillOpacity: 0.05
      })
      this.mapInfo.circular = circular
      this.mapInfo.Map.add(circular)
      return circular
    },
    selAlarm (data, index) {
      this.currentIndex = index
      this.alarmData = data
      this.updateMap()
    },
    calculateHeight () {},
    handleResize () {}
  },
  beforeDestroy () { this.cancel(); this.unsubscribe(); }
}
</script>

<style scoped>
.management-container {
  position: relative;
  height: 720px;
  background: #f0f2f5;
  overflow: hidden;
}

/* 背景地图 - 移除圆角 */
.map-background {
  position: absolute;
  inset: 0;
  z-index: 1;
}

.map-canvas {
  width: 100%;
  height: 100%;
}

/* HUD 地址 */
.hud-address-clean {
  position: absolute;
  top: 24px;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  padding: 6px 20px 6px 6px;
  border-radius: 40px;
  display: flex;
  align-items: center;
  gap: 10px;
  z-index: 10;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}

.hud-icon-box {
  width: 28px;
  height: 28px;
  background: #ff4d4f;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.hud-text {
  color: #333;
  font-size: 14px;
  font-weight: 600;
}

/* 悬浮纯白面板 */
.white-panel {
  position: absolute;
  top: 24px;
  bottom: 24px;
  background: #ffffff;
  border-radius: 16px;
  z-index: 5;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 30px rgba(0,0,0,0.08);
  border: 1px solid #f0f0f0;
}

.panel-left {
  left: 24px;
  width: 340px;
}

.panel-right {
  right: 24px;
  width: 380px;
  padding: 24px;
}

/* 报警列表 */
.panel-header {
  padding: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  font-weight: 700;
  color: #1a1b1d;
}

.status-indicator {
  width: 8px;
  height: 8px;
  background: #ff4d4f;
  border-radius: 50%;
  box-shadow: 0 0 0 4px rgba(255, 77, 79, 0.1);
}

.panel-badge {
  background: #f5f7fa;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  color: #909399;
}

.list-scroll {
  flex: 1;
  overflow-y: auto;
  padding: 5px 16px 24px;
}

.management-card {
  padding: 18px;
  border-radius: 14px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  background: #fff;
  border: 1px solid transparent;
  box-shadow: 0 1px 3px rgba(0,0,0,0.04);
}

.management-card:hover {
  background: #f8f9fb;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
}

.management-card.is-active {
  background: linear-gradient(135deg, #f0f7ff 0%, #e6f4ff 100%);
  border-color: #91d5ff;
  box-shadow: 0 4px 16px rgba(24, 144, 255, 0.15);
}

.card-body {
  display: flex;
  gap: 18px;
  align-items: center;
}

.card-icon-box {
  width: 56px;
  height: 56px;
  background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf0 100%);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
}

.type-icon {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.card-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
  min-width: 0;
}

.info-type {
  font-size: 16px;
  font-weight: 600;
  color: #1a1b1d;
  line-height: 1.4;
  word-break: break-word;
}

.info-time {
  font-size: 13px;
  color: #909399;
  font-weight: 500;
}

/* 详情面板 */
.panel-section {
  margin-bottom: 24px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 700;
  color: #bfbfbf;
  text-transform: uppercase;
  margin-bottom: 20px;
}

.profile-hero {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
}

.clean-avatar {
  border: 2px solid #f0f2f5;
  background: #f5f7fa;
}

.h-name {
  font-size: 18px;
  font-weight: 700;
  color: #1a1b1d;
}

.h-code {
  font-size: 13px;
  color: #909399;
}

.data-item {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  padding: 14px 16px;
  background: #f8f9fb;
  border-radius: 12px;
}

.label {
  font-size: 13px;
  color: #909399;
}

.value {
  font-size: 14px;
  font-weight: 600;
  color: #1a1b1d;
}

.divider {
  height: 1px;
  background: #f0f0f0;
  margin-bottom: 24px;
}

/* 未来感标记样式 */
/deep/ .futuristic-marker {
  position: relative;
  width: 30px;
  height: 30px;
}

/deep/ .marker-core {
  position: absolute;
  inset: 8px;
  background: #ff4d4f;
  border-radius: 50%;
  z-index: 2;
  box-shadow: 0 0 15px rgba(255, 77, 79, 0.8);
}

/deep/ .marker-ring {
  position: absolute;
  inset: 0;
  border: 1px solid rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  animation: marker-ring-pulse 2.5s infinite ease-out;
}

/deep/ .marker-ring-1 {
  animation-delay: 0s;
}

/deep/ .marker-ring-2 {
  animation-delay: 0.8s;
}

/deep/ .marker-ring-3 {
  animation-delay: 1.6s;
}

@keyframes marker-ring-pulse {
  0% { 
    transform: scale(0.8); 
    opacity: 0.9; 
  }
  50% {
    opacity: 0.6;
  }
  100% { 
    transform: scale(4); 
    opacity: 0; 
  }
}

.list-scroll {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
}

.list-scroll::-webkit-scrollbar {
  display: none; /* Chrome/Safari/Opera */
  width: 0;
}

.no-location-tip {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  padding: 12px;
  background: rgba(255, 255, 255, 0.95);
  color: #666;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 500;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

/deep/ .alarm-modal-management .ivu-modal-body {
  padding: 0;
  background: #f0f2f5;
}

.no-data {
  text-align: center;
  color: #666;
}
</style>


// WEBPACK FOOTER //
// src/components/msgNotice/DevAlarmPop.vue